import PropTypes from 'prop-types';
import PubSub from 'pubsub-js';
import React from 'react';

import { PUBSUB_LIVE_CHAT_CLOSED, PUBSUB_LIVE_CHAT_CREATED } from '../../utilities/constants';

const LiveChat = React.memo(function LiveChat({ onClose, ...props }) {
  const ref = React.useRef(null);

  React.useEffect(() => {
    const node = ref.current;

    if (!node) {
      return () => {};
    }

    PubSub.subscribe(PUBSUB_LIVE_CHAT_CREATED, (_, element) => {
      element.style.display = 'block';
      node.appendChild(element);
    });

    const observer = new MutationObserver(mutations => {
      for (const mutation of mutations) {
        if (mutation.type === 'childList' && mutation.removedNodes.length > 0) {
          PubSub.publish(PUBSUB_LIVE_CHAT_CLOSED);

          if (typeof onClose === 'function') {
            onClose();
          }
        }
      }
    });

    observer.observe(node, { childList: true });

    return () => {
      PubSub.unsubscribe(PUBSUB_LIVE_CHAT_CREATED);
      observer.disconnect();
    };
  }, [onClose, ref]);

  return <div {...props} ref={ref} />;
});

LiveChat.propTypes = {
  onClose: PropTypes.func
};

LiveChat.displayName = 'LiveChat';

export default LiveChat;
